import axios, { AxiosResponse } from 'axios';
import { message } from 'antd';
import { setCookie, deleteCookie } from '../utils/cookie';
import { User } from '../UserContext';
import { COOKIE_NAME } from '../configs';

export const resetPassword = async (data: {
  username: string;
  code: string;
  password: string;
}) => {
  let body = {
    password: data.password,
    resetPasswordKey: data.code,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_API +
          '/v1/users/' +
          data.username +
          '/resetpassword',
        body
      )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((error) => {
        message.error('Reset Failed');
        reject(error);
      });
  });
};

export const requestReset = async (username: string) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        process.env.REACT_APP_API + '/v1/users/' + username + '/resetpassword'
      )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((error) => {
        message.error('Request Failed');
        reject(error);
      });
  });
};
export const registerUser = async (data: {
  username: string;
  password: string;
  email: string;
  isUCSD: boolean;
}) => {
  let body = {
    username: data.username,
    password: data.password,
    email: data.email,
    isUCSD: data.isUCSD,
  };
  return new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_API + '/v1/users', body)
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((error) => {
        message.error(error.response?.data?.error?.message ?? 'Registration failed');
        reject(error);
      });
  });
};

export const logoutUser = () => {
  deleteCookie(COOKIE_NAME);
};
export const getUserFromToken = (token: string): User => {
  let res = tokenGetClaims(token);
  return {
    loggedIn: true,
    admin: false,
    username: res.username,
    id: res.playerID,
  };
};

export const tokenGetClaims = (token: string): any => {
  if (!token) {
    return {};
  }
  const tokenArray = token.split('.');
  if (tokenArray.length !== 3) {
    return {};
  }
  return JSON.parse(
    window.atob(tokenArray[1].replace('-', '+').replace('_', '/'))
  );
};

export const loginUser = async (data: { username: string; password: string }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_API + '/v1/auth/login', data)
      .then((res: AxiosResponse) => {
        setCookie(COOKIE_NAME, res.data.token, 7);
        resolve(res.data.token);
      })
      .catch((error) => {
        message.error(error.response?.data?.error?.message ?? 'Login failed');
        reject(error);
      });
  });
};

export const verifyToken = async (token: string) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        process.env.REACT_APP_API + '/v1/auth/verify',
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res: AxiosResponse) => {
        resolve(res);
      })
      .catch((error) => {
        message.error(error.response?.data?.error?.message ?? 'Session check failed');
        reject(error);
      });
  });
};
